import { Component, OnInit } from '@angular/core';

import {
  FormGroup,
  FormControl,
  FormArray,
  Validators,
  Form,
} from '@angular/forms';
import { IOption } from 'src/app/interfaces/option';
import { StoreService } from 'src/app/services/store.service';

import Swal from 'sweetalert2/dist/sweetalert2.js';
import { AppFormat } from '../../appFormat';

@Component({
  selector: 'app-shipping-delivery',
  templateUrl: './shipping-delivery.component.html',
  styleUrls: ['./shipping-delivery.component.scss'],
  host: { class: 'wrapper-settings' },
})
export class ShippingDeliveryComponent implements OnInit {
  public loading: boolean = false;

  public changed: boolean;
  public settingsFrm: FormGroup;

  public status: FormControl;
  public select_delivery_type: FormControl;
  public preco: FormControl;
  public gratis: FormControl;
  public ck_free: FormControl;

  public ck_delivery: FormControl;

  public ds_entrega: FormControl;
  public raio_entrega: FormControl;

  public num_entrega_turno_manha: FormControl;
  public num_entrega_turno_tarde: FormControl;
  public num_entrega_turno_noite: FormControl;

  public delivery_manha_fim: FormControl;
  public delivery_tarde_inicio: FormControl;
  public delivery_tarde_fim: FormControl;
  public delivery_noite_inicio: FormControl;

  public tempo_liberacao_delivery: FormControl;

  public entrega_distancia: FormArray;
  public entrega_faixa: FormArray;
  public holidays: FormArray;

  public scheduling: FormArray;

  public dias_semana: IOption[] = [];
  public formas_entrega: IOption[] = [];
  public startDate = new Date();

  constructor(private storeService: StoreService) {}

  ngOnInit(): void {
    this.changed = false;

    this.formas_entrega.push({ text: 'Todos', value: 'T' });
    this.formas_entrega.push({ text: 'Delivery', value: 'E' });
    this.formas_entrega.push({ text: 'Drive-thru', value: 'R' });

    this.dias_semana.push({ text: 'Domingo', value: '1' });
    this.dias_semana.push({ text: 'Segunda-feira', value: '2' });
    this.dias_semana.push({ text: 'Terça-feira', value: '3' });
    this.dias_semana.push({ text: 'Quarta-feira', value: '4' });
    this.dias_semana.push({ text: 'Quinta-feira', value: '5' });
    this.dias_semana.push({ text: 'Sexta-feira', value: '6' });
    this.dias_semana.push({ text: 'Sábado', value: '7' });

    this.createFormControls();
    this.createForm();

    this.getDeliveryCondig();
  }

  createFormControls() {
    this.status = new FormControl(null);
    this.ds_entrega = new FormControl(null);
    this.select_delivery_type = new FormControl(1);
    this.preco = new FormControl(null);
    this.gratis = new FormControl(null);
    this.ck_free = new FormControl(false);

    this.ck_delivery = new FormControl(false);
    this.raio_entrega = new FormControl(null);

    this.entrega_distancia = new FormArray([]);
    this.entrega_faixa = new FormArray([]);
    this.holidays = new FormArray([]);

    this.scheduling = new FormArray([]);

    this.num_entrega_turno_manha = new FormControl(null);
    this.num_entrega_turno_tarde = new FormControl(null);
    this.num_entrega_turno_noite = new FormControl(null);

    this.delivery_manha_fim = new FormControl('13:00');
    this.delivery_tarde_inicio = new FormControl('13:00');
    this.delivery_tarde_fim = new FormControl('18:00');
    this.delivery_noite_inicio = new FormControl('18:00');

    this.tempo_liberacao_delivery = new FormControl(null);
  }

  createForm() {
    this.settingsFrm = new FormGroup({
      status: this.status,
      ds_entrega: this.ds_entrega,
      raio_entrega: this.raio_entrega,
      select_delivery_type: this.select_delivery_type,
      preco: this.preco,
      gratis: this.gratis,
      ck_free: this.ck_free,
      entrega_distancia: this.entrega_distancia,
      entrega_faixa: this.entrega_faixa,
      holidays: this.holidays,
      ck_delivery: this.ck_delivery,
      scheduling: this.scheduling,
      num_entrega_turno_manha: this.num_entrega_turno_manha,
      num_entrega_turno_tarde: this.num_entrega_turno_tarde,
      num_entrega_turno_noite: this.num_entrega_turno_noite,
      tempo_liberacao_delivery: this.tempo_liberacao_delivery,
      delivery_manha_fim: this.delivery_manha_fim,
      delivery_tarde_inicio: this.delivery_tarde_inicio,
      delivery_tarde_fim: this.delivery_tarde_fim,
      delivery_noite_inicio: this.delivery_noite_inicio,
    });
  }

  getDeliveryCondig() {
    this.loading = true;
    this.storeService.getDelivery().subscribe((res) => {
      this.resDelivey(res);
      this.loading = false;
    });
  }

  resDelivey(res) {
    if (res['success'] == true) {
      let delivery = res['delivery'];
      if (delivery['idestabelecimento_entrega']) {
        this.ds_entrega.setValue(delivery['ds_entrega']);
        this.preco.setValue(delivery['valor']);
        this.gratis.setValue(delivery['gratis']);

        this.select_delivery_type.setValue(
          parseFloat(delivery['valor']) > 0 ? '2' : '1'
        );
        this.ck_free.setValue(parseFloat(delivery['gratis']) > 0);

        //
        if (delivery['distancias'] && delivery['distancias'].length > 0) {
          this.entrega_distancia.clear();
          for (let i in delivery['distancias']) {
            this.onAddNewDistance({
              id: delivery['distancias'][i][
                'idestabelecimento_entrega_distancia'
              ],
              distancia: delivery['distancias'][i]['distancia_final'],
              valor: delivery['distancias'][i]['valor'],
            });
          }
        }

        if (delivery['faixas'] && delivery['faixas'].length > 0) {
          this.entrega_faixa.clear();
          for (let i in delivery['faixas']) {
            this.onAddNewCEP({
              faixa_inicial: delivery['faixas'][i]['faixa_inicial'],
              faixa_final: delivery['faixas'][i]['faixa_final'],
              valor: delivery['faixas'][i]['valor'],
              ignora_distancia: delivery['faixas'][i]['ignora_distancia'],
              dentro_raio: delivery['faixas'][i]['dentro_raio'],
            });
          }
        }
      }
      let holidays = res['holidays'];
      if (holidays && holidays.length > 0) {
        this.holidays.clear();
        for (let i in holidays) {
          let dia = holidays[i]['dia'].split(' ');
          dia = AppFormat.dateYMDUTCMoment(dia[0]);

          this.onAddNewHoliday({
            dia: dia,
            tipo: holidays[i]['tipo'],
          });
        }
      }

      this.status.setValue(delivery['delivery'] == 'S');
      this.raio_entrega.setValue(delivery['raio_entrega']);

      /**
       *
       *
       * agendamento
       *
       */
      let agendamento = res['agendamento'];

      if (agendamento) {
        this.ck_delivery.setValue(agendamento['delivery'] == 'S');

        this.tempo_liberacao_delivery.setValue(
          agendamento['tempo_liberacao_delivery']
        );

        this.num_entrega_turno_manha.setValue(
          agendamento['num_entrega_turno_manha']
        );
        this.num_entrega_turno_tarde.setValue(
          agendamento['num_entrega_turno_tarde']
        );
        this.num_entrega_turno_noite.setValue(
          agendamento['num_entrega_turno_noite']
        );

        this.delivery_manha_fim.setValue(agendamento['delivery_manha_fim']);
        this.delivery_tarde_inicio.setValue(
          agendamento['delivery_tarde_inicio']
        );
        this.delivery_tarde_fim.setValue(agendamento['delivery_tarde_fim']);
        this.delivery_noite_inicio.setValue(
          agendamento['delivery_noite_inicio']
        );

        if (agendamento['scheduling'] && agendamento['scheduling'].length > 0) {
          this.scheduling.clear();
          for (let i in agendamento['scheduling']) {
            this.onAddNewRangeHour({
              diasemana: parseInt(
                agendamento['scheduling'][i]['diasemana']
              ).toString(),
              hora_inicio: agendamento['scheduling'][i]['hora_inicio'],
              hora_fim: agendamento['scheduling'][i]['hora_fim'],
              num_entregas: agendamento['scheduling'][i]['num_entregas'],
              tempo_liberacao: agendamento['scheduling'][i]['tempo_liberacao'],
            });
          }
        }
      }
    }
  }

  onAddNewDistance(obj) {
    this.entrega_distancia.push(
      new FormGroup({
        id: new FormControl(obj != undefined && obj.id ? obj.id : null),
        distancia: new FormControl(
          obj != undefined && obj.distancia ? obj.distancia : null
        ),
        valor: new FormControl(
          obj != undefined && obj.valor ? obj.valor : null
        ),
      })
    );
  }

  onRemoveDistance(i) {
    Swal.fire({
      title: 'Você deseja remover a distância?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false,
    }).then((result) => {
      if (result.value) {
        this.entrega_distancia.removeAt(i);
        this.onChangeDetail();
      }
    });
  }

  onAddNewHoliday(obj) {
    this.holidays.push(
      new FormGroup({
        dia: new FormControl(obj != undefined && obj.dia ? obj.dia : null),
        tipo: new FormControl(obj != undefined && obj.tipo ? obj.tipo : null),
      })
    );
  }

  onRemoveHoliday(i) {
    Swal.fire({
      title: 'Você deseja remover esta data?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false,
    }).then((result) => {
      if (result.value) {
        let fGroup = <FormGroup>this.holidays.controls[i];
        let tipo = <FormControl>fGroup.controls.tipo;

        tipo.setValue(-1);

        this.onChangeDetail();
      }
    });
  }

  onAddNewCEP(obj) {
    this.entrega_faixa.push(
      new FormGroup({
        faixa_inicial: new FormControl(
          obj != undefined && obj.faixa_inicial ? obj.faixa_inicial : null
        ),
        faixa_final: new FormControl(
          obj != undefined && obj.faixa_final ? obj.faixa_final : null
        ),
        valor: new FormControl(
          obj != undefined && obj.valor ? obj.valor : null
        ),
        ignora_distancia: new FormControl(
          obj != undefined && obj.ignora_distancia == 'S' ? true : false
        ),
        dentro_raio: new FormControl(
          obj != undefined && obj.dentro_raio == 'S' ? true : false
        ),
      })
    );
  }

  onRemoveCEP(i) {
    Swal.fire({
      title: 'Você deseja remover a faixa de CEP?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false,
    }).then((result) => {
      if (result.value) {
        let fGroup = <FormGroup>this.entrega_faixa.controls[i];
        let valor = <FormControl>fGroup.controls.valor;

        valor.setValue(-1);

        this.onChangeDetail();
      }
    });
  }

  onAddNewRangeHour(obj) {
    this.scheduling.push(
      new FormGroup({
        diasemana: new FormControl(
          obj != undefined && obj.diasemana ? obj.diasemana : null
        ),
        hora_inicio: new FormControl(
          obj != undefined && obj.hora_inicio ? obj.hora_inicio : null
        ),
        hora_fim: new FormControl(
          obj != undefined && obj.hora_fim ? obj.hora_fim : null
        ),
        num_entregas: new FormControl(
          obj != undefined && obj.num_entregas ? obj.num_entregas : null
        ),
        tempo_liberacao: new FormControl(
          obj != undefined && obj.tempo_liberacao ? obj.tempo_liberacao : null
        ),
      })
    );
  }

  onRemoveRangeHour(i) {
    Swal.fire({
      title: 'Você deseja remover este horário?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false,
    }).then((result) => {
      if (result.value) {
        let fGroup = <FormGroup>this.scheduling.controls[i];
        let diasemana = <FormControl>fGroup.controls.diasemana;

        diasemana.setValue(-1);

        this.onChangeDetail();
      }
    });
  }

  onChangeDetail() {
    this.changed = true;
  }

  onCheckValid(i) {
    let check = true;

    let fGroup = <FormGroup>this.scheduling.controls[i];
    let diasemana = <FormControl>fGroup.controls.diasemana;

    let semana = diasemana.value;

    for (let j in this.scheduling.controls) {
      if (j != i) {
        let fGroup = <FormGroup>this.scheduling.controls[j];
        let diasemana = <FormControl>fGroup.controls.diasemana;

        if (diasemana.value == semana) {
          check = null;
          break;
        }
      }
    }

    return check;
  }

  onCancel() {
    Swal.fire({
      title: 'Você deseja cancelar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
    }).then((result) => {
      if (result.value) {
        this.loading = true;
        this.changed = false;
        this.getDeliveryCondig();
      }
    });
  }

  saveError() {
    Swal.fire('Ops!', 'Ocorreu um erro ao tentar salvar.', 'error');
  }

  saveComplete() {
    Swal.fire(
      'Salvo!',
      'As configuraçõs de frete e entrega foram salvas',
      'success'
    );
  }

  saving() {
    Swal.fire({
      title: 'Salvando...',
      icon: 'info',
      showCancelButton: false,
      allowOutsideClick: false,
      showConfirmButton: false,
    });
  }

  onSubmit() {
    let data = {
      delivery: this.status.value ? 'S' : 'N',
      valor: this.select_delivery_type.value == '1' ? 0 : this.preco.value,
      raio_entrega: this.raio_entrega.value,
      gratis: this.ck_free.value ? this.gratis.value : 0,
      ds_entrega: this.ds_entrega.value,
      entrega_distancia: [],
      entrega_faixa: [],
      holidays: [],
    };

    let entrega_distancia = [];

    for (let i in this.entrega_distancia.controls) {
      let fGroup = <FormGroup>this.entrega_distancia.controls[i];

      let distancia = <FormControl>fGroup.controls.distancia;
      let valor = <FormControl>fGroup.controls.valor;

      if (
        distancia.value != null &&
        distancia.value != '' &&
        valor.value != null &&
        valor.value != ''
      ) {
        let km = parseFloat(distancia.value);
        let v = parseFloat(valor.value);
        if (km > 0 && v > 0) {
          let id = <FormControl>fGroup.controls.id;

          entrega_distancia.push({ id: id.value, distancia: km, valor: v });
        }
      }
    }

    entrega_distancia.sort(
      (a, b) => parseFloat(a.distancia) - parseFloat(b.distancia)
    );

    let lst_distancia = [];
    let distancia_ant = 0;
    for (let i in entrega_distancia) {
      let d = entrega_distancia[i];
      lst_distancia.push([d.id, distancia_ant, d.distancia, d.valor]);

      distancia_ant = d.distancia;
    }

    data['entrega_distancia'] = lst_distancia;

    let entrega_faixa = [];
    for (let i in this.entrega_faixa.controls) {
      let fGroup = <FormGroup>this.entrega_faixa.controls[i];

      let faixa_inicial = <FormControl>fGroup.controls.faixa_inicial;

      if (faixa_inicial.value != null && faixa_inicial.value != '') {
        let valor = <FormControl>fGroup.controls.valor;
        let faixa_final = <FormControl>fGroup.controls.faixa_final;
        let ignora_distancia = <FormControl>fGroup.controls.ignora_distancia;
        let dentro_raio = <FormControl>fGroup.controls.dentro_raio;

        entrega_faixa.push([
          faixa_inicial.value,
          faixa_final.value,
          valor.value,
          ignora_distancia.value ? 'S' : 'N',
          dentro_raio.value ? 'S' : 'N',
        ]);
      }
    }
    data['entrega_faixa'] = entrega_faixa;

    let holidays = [];
    for (let i in this.holidays.controls) {
      let fGroup = <FormGroup>this.holidays.controls[i];

      let dia = <FormControl>fGroup.controls.dia;

      if (dia.value != null && dia.value != '') {
        let tdia = '';
        if (dia.value != null && typeof dia.value === 'object') {
          tdia = dia.value.format('YYYY-MM-DD');
        } else {
          tdia = dia.value;
        }

        let tipo = <FormControl>fGroup.controls.tipo;

        holidays.push([tdia, tipo.value]);
      }
    }
    data['holidays'] = holidays;

    let agendamento = {
      delivery: this.ck_delivery.value ? 'S' : 'N',
      tempo_liberacao_delivery: this.tempo_liberacao_delivery.value,
      num_entrega_turno_manha: this.num_entrega_turno_manha.value,
      num_entrega_turno_tarde: this.num_entrega_turno_tarde.value,
      num_entrega_turno_noite: this.num_entrega_turno_noite.value,
      delivery_manha_fim: this.delivery_manha_fim.value,
      delivery_tarde_inicio: this.delivery_tarde_inicio.value,
      delivery_tarde_fim: this.delivery_tarde_fim.value,
      delivery_noite_inicio: this.delivery_noite_inicio.value,
    };

    let scheduling = [];
    for (let i in this.scheduling.controls) {
      let fGroup = <FormGroup>this.scheduling.controls[i];

      let diasemana = <FormControl>fGroup.controls.diasemana;
      let hora_inicio = <FormControl>fGroup.controls.hora_inicio;
      let hora_fim = <FormControl>fGroup.controls.hora_fim;

      if (
        diasemana.value != null &&
        diasemana.value != '' &&
        hora_inicio.value != null &&
        hora_inicio.value != '' &&
        hora_fim.value != null &&
        hora_fim.value != ''
      ) {
        let num_entregas = <FormControl>fGroup.controls.num_entregas;
        let tempo_liberacao = <FormControl>fGroup.controls.tempo_liberacao;
        scheduling.push([
          diasemana.value,
          hora_inicio.value,
          hora_fim.value,
          num_entregas.value,
          tempo_liberacao.value,
        ]);
      }
    }

    agendamento['scheduling'] = scheduling;
    data['agendamento'] = agendamento;

    this.saving();

    this.storeService.storeDelivery(data).subscribe((res) => {
      if (res['success']) {
        //
        this.resDelivey(res);
        //
        this.changed = false;
        //
        this.saveComplete();
      } else {
        this.saveError();
      }
    });

    return null;
  }
}
